export default function RankingBadge({ ranking }) {
  if (!ranking) return null;

  const key = ranking?.toLowerCase();

  const styleMap = {
    ajss: "bg-red-100 text-red-700",
    national: "bg-green-100 text-green-700",

    // future ranking types
    psa: "bg-indigo-100 text-indigo-700",
    state: "bg-yellow-100 text-yellow-700",
    club: "bg-gray-200 text-gray-700",
    international: "bg-blue-100 text-blue-700",
  };

  const styles = styleMap[key] || "bg-gray-200 text-gray-600";

  return (
    <span className={`px-2 py-1 text-xs rounded-full ${styles}`}>
      {ranking}
    </span>
  );
}
